import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { AzavistaButtonModule } from '@azavista/components/button';
import { TranslateModule } from '@ngx-translate/core';
import { NavbarProfileComponent } from './navbar-profile/navbar-profile.component';

@NgModule({
    declarations: [
        NavbarProfileComponent,
    ],
    imports: [
        CommonModule,

        MatIconModule,
        MatMenuModule,
        TranslateModule,

        AzavistaButtonModule
    ],
    exports: [
        NavbarProfileComponent
    ]
})
export class NavbarModule {}
